import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as Maps from '../../store/map';

function MultiMiniCalculator(props) {
    const handleSetMultiStake = (value) => {
        props.setMultiStake(value);
    };

    let { openCalculator } = props;
    let { multiStake } = props.betslip;

    return (
        <Row className="p-0 pb-1 pt-1 betslip-panel mx-auto">
            <Col xs="8" className="mx-auto display-flex pr-0 pl-0">
                <Col
                    xs="2"
                    className="cal-btn bg-green m-l"
                    onClick={(e) => {
                        e.preventDefault();
                        handleSetMultiStake(5.0);
                    }}
                >
                    <div id="1">5</div>
                </Col>
                <Col
                    xs="2"
                    className="cal-btn bg-green m-l-r"
                    onClick={(e) => {
                        e.preventDefault();
                        handleSetMultiStake(10.0);
                    }}
                >
                    <div>10</div>
                </Col>
                <Col
                    xs="2"
                    className="cal-btn bg-green"
                    onClick={(e) => {
                        e.preventDefault();
                        handleSetMultiStake(20.0);
                    }}
                >
                    <div>20</div>
                </Col>
                <Col
                    xs="2"
                    className="cal-btn bg-green m-l-r"
                    onClick={(e) => {
                        e.preventDefault();
                        handleSetMultiStake(50.0);
                    }}
                >
                    <div>50</div>
                </Col>
                <Col
                    xs="2"
                    className="cal-btn bg-green"
                    onClick={(e) => {
                        e.preventDefault();
                        handleSetMultiStake(100.0);
                    }}
                >
                    <div>100</div>
                </Col>
            </Col>
            <Col xs="4" className="m-l mx-auto display-flex pl-0">
                <Col xs="8" className="btn-cal-white m-r-6 pr-1 pl-1">
                    <div onClick={openCalculator}>{parseFloat(multiStake).toFixed(2)}</div>
                </Col>
                <Col xs="4" className="p-0 pt-2">
                    <div>EUR</div>
                </Col>
            </Col>
        </Row>
    );
}

export default connect(Maps.mapBetslipStateToProps, Maps.mapBetslipDispatchToProps)(MultiMiniCalculator);
